import React from 'react';
import { styled } from '@mui/material';
import { Colors } from 'library';

interface RCheckboxProps {
    checked: boolean;
    onChange: (checked: boolean) => void;
    label?: string;
    size?: 'default' | 'small';
}

export function RCheckbox({ checked, onChange, label, size = 'default' }: RCheckboxProps) {
    const small = size === 'small';

    if (label) {
        return (
            <LabelWrapper>
                <StyledCheckbox
                    type="checkbox"
                    checked={checked}
                    onChange={(e) => onChange(e.target.checked)}
                    small={small}
                />
                <LabelText small={small}>{label}</LabelText>
            </LabelWrapper>
        );
    }

    return (
        <StyledCheckbox type="checkbox" checked={checked} onChange={(e) => onChange(e.target.checked)} small={small} />
    );
}

const LabelWrapper = styled('label')({
    display: 'flex',
    alignItems: 'center',
    gap: 6,
    cursor: 'pointer',
});

const LabelText = styled('span')<{ small: boolean }>(({ small }) => ({
    fontSize: small ? 12 : 14,
    fontWeight: 500,
    lineHeight: small ? '16px' : '18px',
    color: 'inherit',
}));

const StyledCheckbox = styled('input')<{ small: boolean }>(({ small }) => ({
    width: small ? 14 : 18,
    height: small ? 14 : 18,
    margin: 0,
    cursor: 'pointer',
    accentColor: Colors.darkNavy,
    flexShrink: 0,
}));
